import { createSelector } from 'reselect'

import { SITE_AUDIT_PROJECT_DOMAIN } from '../../utils/consts.mjs'

/**
 * Direct selector to the app state domain
 */
export const selectSiteAudit = () => (state) => state.siteAudit

export const selectSiteAuditState = () =>
  createSelector(selectSiteAudit(), (substate) => substate[substate.type])

export const selectPagesDiscovered = () =>
  createSelector(
    selectSiteAudit(),
    (substate) => substate[substate.type].pagesDiscovered,
  )

export const selectIssueBreakdown = () =>
  createSelector(
    selectSiteAudit(),
    (substate) => substate[substate.type].issueBreakdown,
  )

export const selectIssueIgnored = () =>
  createSelector(
    selectSiteAudit(),
    (substate) => substate[substate.type].issueIgnored,
  )

export const selectIssueDiff = () =>
  createSelector(
    selectSiteAudit(),
    (substate) => substate[substate.type].issueDiff,
  )

export const selectIsCrawling = () =>
  createSelector(
    selectSiteAudit(),
    (substate) => substate?.[substate?.type || '']?.isCrawling,
  )

export const selectProjectIsCrawling = () =>
  createSelector(
    selectSiteAudit(),
    (substate) => substate[SITE_AUDIT_PROJECT_DOMAIN].isCrawling,
  )

export const selectStopCrawling = () =>
  createSelector(
    selectSiteAudit(),
    (substate) => substate[substate.type].stopCrawling,
  )

export const selectProjectStopCrawling = () =>
  createSelector(
    selectSiteAudit(),
    (substate) => substate[SITE_AUDIT_PROJECT_DOMAIN].stopCrawling,
  )

export const selectSiteAuditData = () =>
  createSelector(
    selectSiteAudit(),
    (substate) => substate[substate.type].siteAuditData,
  )

export const selectDone = () =>
  createSelector(selectSiteAudit(), (substate) => substate[substate.type].done)

export const selectCrawlingErrorText = () =>
  createSelector(
    selectSiteAudit(),
    (substate) => substate[substate.type].crawlingErrorText,
  )

export const selectPartialSiteAuditData = () =>
  createSelector(
    selectSiteAudit(),
    (substate) => substate[substate.type].partialSiteAudit,
  )

export const selectIsPolling = () =>
  createSelector(
    selectSiteAudit(),
    (substate) => substate[substate.type].isPolling,
  )

export const selectDisplayUpgradeModal = () =>
  createSelector(
    selectSiteAudit(),
    (substate) => substate[substate.type].displayUpgradeModal,
  )

export const selectIsLoadingDomainOverview = () =>
  createSelector(
    selectSiteAudit(),
    (substate) => substate[substate.type].isLoadingDomainOverview,
  )

export const selectIsCancelled = () =>
  createSelector(
    selectSiteAudit(),
    (substate) => substate[substate.type].isCancelledCrawling,
  )

export const selectSiteAuditDomainType = () =>
  createSelector(selectSiteAudit(), (substate) => substate.type)

export const selectProjectSiteAuditData = () =>
  createSelector(selectSiteAudit(), (substate) => substate.project)
